import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const LinkWithFilters = ({ filter, to, ...props }) => {
  const [search, setSearch] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams();
    if (filter.portfolioIds.length > 0) {
      searchParams.append('portfolioIds', filter.portfolioIds);
    }

    if (filter.assetIds.length > 0) {
      searchParams.append('assetIds', filter.assetIds);
    }

    if (filter.assetTypes.length > 0) {
      searchParams.append('types', filter.assetTypes);
    }

    if (filter.assetsStatus.length > 0) {
      searchParams.append('statuses', filter.assetsStatus);
    }

    if (filter.managers.length > 0) {
      searchParams.append('managers', filter.managers);
    }

    if (filter.showActiveTenantsOnly) {
      searchParams.append('showActiveTenantsOnly', filter.showActiveTenantsOnly);
    }

    setSearch(searchParams.toString());
  }, [filter]);

  return (
    <Link
      to={{
        pathname: to,
        search: `?${search}`,
      }}
      {...props}
    />
  )
};

export default LinkWithFilters;
